import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageNo = () => {
    return <MakeHomepage languageCode="no" />
}

export default MakeHomepageNo
